
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.222 11.667h3.556a.724.724 0 00.722-.722v-.223a.724.724 0 00-.722-.722H8.223a.724.724 0 00-.722.722v.223c0 .397.324.722.722.722zM15 15c0 .46-.373.833-.833.833H5.833A.835.835 0 015 15V7.5h10V15zM5 4.167h10a.834.834 0 010 1.666H5A.835.835 0 014.167 5c0-.46.374-.833.833-.833zM17.5 5c0-1.378-1.122-2.5-2.5-2.5H5A2.503 2.503 0 002.5 5c0 .736.326 1.392.833 1.85V15c0 1.378 1.122 2.5 2.5 2.5h8.334c1.378 0 2.5-1.122 2.5-2.5V6.85A2.487 2.487 0 0017.5 5z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.222 11.667h3.556a.724.724 0 00.722-.722v-.223a.724.724 0 00-.722-.722H8.223a.724.724 0 00-.722.722v.223c0 .397.324.722.722.722zM15 15c0 .46-.373.833-.833.833H5.833A.835.835 0 015 15V7.5h10V15zM5 4.167h10a.834.834 0 010 1.666H5A.835.835 0 014.167 5c0-.46.374-.833.833-.833zM17.5 5c0-1.378-1.122-2.5-2.5-2.5H5A2.503 2.503 0 002.5 5c0 .736.326 1.392.833 1.85V15c0 1.378 1.122 2.5 2.5 2.5h8.334c1.378 0 2.5-1.122 2.5-2.5V6.85A2.487 2.487 0 0017.5 5z"}})])
          )
        }
      }
    